export interface Comic {
  id: string;
  title: string;
  cover: string;
  category: string;
  author: string;
  status: "连载中" | "已完结";
  score: number;
  description: string;
  tags: string[];
  chapters: number;
  updateTime: string;
  views: number;
  isEditorPick: boolean;
  isHot: boolean;
  region: string;
  year: number;
  lastChapter: string;
}

export const categories = [
  { name: "少年热血", icon: "ri-fire-line", desc: "燃向战斗与成长" },
  { name: "恋爱日常", icon: "ri-heart-line", desc: "心动与甜甜日常" },
  { name: "玄幻奇幻", icon: "ri-sparkling-line", desc: "幻想世界大冒险" },
  { name: "悬疑推理", icon: "ri-search-eye-line", desc: "烧脑解谜与反转" },
  { name: "科幻机甲", icon: "ri-rocket-2-line", desc: "未来科技与机甲" },
  { name: "校园青春", icon: "ri-graduation-cap-line", desc: "青春与成长故事" },
  { name: "古风仙侠", icon: "ri-sword-line", desc: "仙侠江湖恩怨" },
  { name: "搞笑轻松", icon: "ri-emotion-happy-line", desc: "轻松治愈笑料多" },
];

export const comics: Comic[] = [
  {
    id: "manhua-xinghuoliaoyuan",
    title: "星火燎原",
    cover: "https://readdy.ai/api/search-image?query=Vibrant%20anime%20manga%20cover%20art%20of%20a%20determined%20young%20hero%20holding%20a%20blazing%20flame%20in%20his%20palm%2C%20dynamic%20crimson%20and%20orange%20flames%20swirling%20behind%20him%2C%20shonen%20action%20style%2C%20warm%20glowing%20atmosphere%2C%20clean%20minimal%20background%2C%20dramatic%20lighting%2C%20high%20detail%20digital%20illustration&width=600&height=800&seq=manhua-01&orientation=portrait",
    category: "少年热血",
    author: "陈默",
    status: "连载中",
    score: 9.6,
    description: "废土末世中，少年阿辉觉醒了操控火焰的能力。为寻找失踪的妹妹，他踏上横穿大陆的旅程，与各怀绝技的伙伴并肩作战，一步步揭开末日真相。",
    tags: ["热血", "战斗", "末世", "成长"],
    chapters: 286,
    updateTime: "2小时前",
    views: 8620000,
    isEditorPick: true,
    isHot: true,
    region: "国产",
    year: 2021,
    lastChapter: "第286话 破晓之前",
  },
  {
    id: "manhua-xintiaofangchengshi",
    title: "心跳方程式",
    cover: "https://readdy.ai/api/search-image?query=Romantic%20anime%20manga%20cover%20art%20of%20a%20shy%20couple%20meeting%20under%20soft%20cherry%20blossoms%2C%20blushing%20expressions%2C%20sweet%20sakura%20petals%20floating%2C%20warm%20pastel%20pink%20and%20cream%20tones%2C%20clean%20simple%20background%2C%20soft%20glow%2C%20cute%20slice%20of%20life%20style%2C%20high%20detail%20illustration&width=600&height=800&seq=manhua-02&orientation=portrait",
    category: "恋爱日常",
    author: "顾一甜",
    status: "连载中",
    score: 9.1,
    description: "数学天才少女遇上理科白痴学弟，两人组队参加全国奥数竞赛。一次次解题与心跳碰撞，公式背后藏着最动人的青春告白。",
    tags: ["校园", "甜宠", "恋爱", "成长"],
    chapters: 156,
    updateTime: "4小时前",
    views: 4980000,
    isEditorPick: true,
    isHot: false,
    region: "国产",
    year: 2022,
    lastChapter: "第156话 答案是你",
  },
  {
    id: "manhua-shanhaiyiwulu",
    title: "山海异闻录",
    cover: "https://readdy.ai/api/search-image?query=Fantasy%20anime%20manga%20cover%20art%20of%20a%20mystical%20mountain%20with%20floating%20ancient%20palaces%20and%20mythical%20beasts%2C%20xianxia%20cultivation%20world%2C%20misty%20teal%20and%20jade%20green%20palette%20with%20golden%20accents%2C%20epic%20scale%2C%20clean%20background%2C%20atmospheric%20glow%2C%20high%20detail%20fantasy%20illustration&width=600&height=800&seq=manhua-03&orientation=portrait",
    category: "玄幻奇幻",
    author: "九霄",
    status: "已完结",
    score: 9.4,
    description: "凡间书生误入山海秘境，偶得上古残卷，从此踏上降妖问道之路。仙山、异兽、宗门恩怨，一部荡气回肠的东方玄幻史诗。",
    tags: ["玄幻", "仙侠", "冒险", "史诗"],
    chapters: 412,
    updateTime: "已完结",
    views: 9230000,
    isEditorPick: true,
    isHot: true,
    region: "国产",
    year: 2019,
    lastChapter: "全书完",
  },
  {
    id: "manhua-miwudangan",
    title: "迷雾档案",
    cover: "https://readdy.ai/api/search-image?query=Dark%20mystery%20thriller%20anime%20manga%20cover%20of%20a%20detective%20in%20a%20trench%20coat%20standing%20in%20fog%2C%20neon%20city%20lights%20behind%2C%20ominous%20teal%20and%20charcoal%20tones%20with%20hints%20of%20amber%2C%20noir%20moody%20lighting%2C%20clean%20dark%20background%2C%20high%20detail%20thriller%20illustration&width=600&height=800&seq=manhua-04&orientation=portrait",
    category: "悬疑推理",
    author: "白夜",
    status: "连载中",
    score: 9.5,
    description: "刑警林深与神秘档案管理员搭档，追查一连串跨越二十年的离奇案件。每个档案背后都藏着一个不为人知的秘密。",
    tags: ["悬疑", "推理", "刑侦", "反转"],
    chapters: 132,
    updateTime: "1天前",
    views: 6340000,
    isEditorPick: false,
    isHot: true,
    region: "国产",
    year: 2023,
    lastChapter: "第132话 卷宗·拾叁",
  },
  {
    id: "manhua-jizhanjiyuan",
    title: "机战纪元",
    cover: "https://readdy.ai/api/search-image?query=Mecha%20sci-fi%20anime%20manga%20cover%20art%20of%20a%20giant%20mecha%20robot%20in%20space%2C%20glowing%20blue%20energy%20core%20and%20metallic%20panels%2C%20starry%20nebula%20background%2C%20warm%20highlight%20and%20cool%20shadows%2C%20epic%20cinematic%20composition%2C%20clean%20space%20background%2C%20high%20detail%20sci-fi%20illustration&width=600&height=800&seq=manhua-05&orientation=portrait",
    category: "科幻机甲",
    author: "钢铁之心",
    status: "连载中",
    score: 8.9,
    description: "星际殖民时代，地球防线告急。少年机师雷诺驾驶父亲的遗产机甲，在浩瀚星海中为人类的生存而战。",
    tags: ["科幻", "机甲", "太空", "战争"],
    chapters: 198,
    updateTime: "3天前",
    views: 4210000,
    isEditorPick: false,
    isHot: false,
    region: "国产",
    year: 2020,
    lastChapter: "第198话 星海誓约",
  },
  {
    id: "manhua-xiariyuanbai",
    title: "夏日告白",
    cover: "https://readdy.ai/api/search-image?query=Summer%20school%20romance%20anime%20manga%20cover%20of%20two%20students%20on%20a%20sunny%20rooftop%20with%20blue%20sky%20and%20white%20clouds%2C%20bicycle%20nearby%2C%20golden%20afternoon%20sunlight%2C%20fresh%20light%20blue%20and%20warm%20yellow%20tones%2C%20clean%20bright%20background%2C%20nostalgic%20youthful%20mood%2C%20high%20detail%20illustration&width=600&height=800&seq=manhua-06&orientation=portrait",
    category: "校园青春",
    author: "初夏",
    status: "已完结",
    score: 8.8,
    description: "转学生林晓晓在高中的最后一个夏天，认识了那个总在篮球场上挥汗如雨的少年。青涩而灿烂的青春，在蝉鸣中悄然盛开。",
    tags: ["青春", "校园", "初恋", "治愈"],
    chapters: 88,
    updateTime: "已完结",
    views: 3760000,
    isEditorPick: false,
    isHot: false,
    region: "国产",
    year: 2020,
    lastChapter: "全书完",
  },
  {
    id: "manhua-jianyuchangan",
    title: "剑雨长安",
    cover: "https://readdy.ai/api/search-image?query=Ancient%20Chinese%20xianxia%20swordsman%20anime%20manga%20cover%20art%2C%20a%20young%20swordsman%20in%20flowing%20robes%20with%20a%20glowing%20sword%2C%20ink%20wash%20painting%20style%20background%20with%20ancient%20city%20walls%2C%20vermilion%20and%20ink%20black%20tones%20with%20gold%20accents%2C%20elegant%20traditional%20mood%2C%20clean%20background%2C%20high%20detail%20illustration&width=600&height=800&seq=manhua-07&orientation=portrait",
    category: "古风仙侠",
    author: "长安客",
    status: "连载中",
    score: 9.2,
    description: "盛唐长安，剑阁弟子陆沉下山历练，卷入朝堂与江湖的惊天棋局。一剑可斩山河，一诺重逾千钧。",
    tags: ["古风", "仙侠", "江湖", "权谋"],
    chapters: 224,
    updateTime: "6小时前",
    views: 7010000,
    isEditorPick: true,
    isHot: true,
    region: "国产",
    year: 2022,
    lastChapter: "第224话 长安夜雨",
  },
  {
    id: "manhua-tucaoanran",
    title: "吐槽达人",
    cover: "https://readdy.ai/api/search-image?query=Comedy%20anime%20manga%20cover%20art%20of%20a%20cheerful%20young%20man%20with%20exaggerated%20funny%20expression%2C%20speech%20bubbles%20and%20comic%20effects%20around%20him%2C%20bright%20orange%20and%20yellow%20playful%20colors%2C%20clean%20simple%20background%2C%20cartoonish%20lighthearted%20mood%2C%20high%20detail%20illustration&width=600&height=800&seq=manhua-08&orientation=portrait",
    category: "搞笑轻松",
    author: "土豆君",
    status: "连载中",
    score: 8.7,
    description: "毒舌漫画家阿哲原本只想安静画画，却总被生活逼着疯狂吐槽。一桩桩鸡飞狗跳的日常，笑到停不下来。",
    tags: ["搞笑", "日常", "吐槽", "治愈"],
    chapters: 176,
    updateTime: "1天前",
    views: 3890000,
    isEditorPick: false,
    isHot: true,
    region: "国产",
    year: 2023,
    lastChapter: "第176话 完美计划",
  },
  {
    id: "manhua-rexuegaoxiao",
    title: "热血高校",
    cover: "https://readdy.ai/api/search-image?query=School%20fight%20shonen%20anime%20manga%20cover%20art%20of%20a%20group%20of%20determined%20high%20school%20students%20in%20uniforms%20walking%20toward%20battle%2C%20fist%20clenched%2C%20dynamic%20red%20and%20crimson%20tones%2C%20school%20rooftop%20background%2C%20energetic%20powerful%20mood%2C%20clean%20background%2C%20high%20detail%20shonen%20illustration&width=600&height=800&seq=manhua-09&orientation=portrait",
    category: "少年热血",
    author: "热血漫社",
    status: "已完结",
    score: 9.0,
    description: "不良少年张扬意外进入全国最强武术高中，为了守护珍视之人，他一步步成为校园传说。拳拳到肉的青春热血。",
    tags: ["热血", "校园", "格斗", "友情"],
    chapters: 320,
    updateTime: "已完结",
    views: 8450000,
    isEditorPick: true,
    isHot: false,
    region: "国产",
    year: 2018,
    lastChapter: "全书完",
  },
  {
    id: "manhua-lianyushenkong",
    title: "恋与深空",
    cover: "https://readdy.ai/api/search-image?query=Romantic%20sci-fi%20anime%20manga%20cover%20art%20of%20a%20couple%20stargazing%20under%20a%20milky%20way%20sky%2C%20glowing%20stars%20and%20aurora%2C%20deep%20blue%20night%20with%20warm%20amber%20lights%2C%20dreamy%20romantic%20atmosphere%2C%20clean%20starry%20background%2C%20high%20detail%20illustration&width=600&height=800&seq=manhua-10&orientation=portrait",
    category: "恋爱日常",
    author: "银河写手",
    status: "已完结",
    score: 9.3,
    description: "天文台研究员苏晚与孤独的天文学家程野，在观测星空的深夜相遇。当宇宙的浪漫遇见世俗的温柔，是一场跨越光年的告白。",
    tags: ["恋爱", "科幻", "治愈", "成人向"],
    chapters: 142,
    updateTime: "已完结",
    views: 5120000,
    isEditorPick: true,
    isHot: false,
    region: "国产",
    year: 2021,
    lastChapter: "全书完",
  },
  {
    id: "manhua-mijingtanxiandui",
    title: "秘境探险队",
    cover: "https://readdy.ai/api/search-image?query=Adventure%20fantasy%20anime%20manga%20cover%20art%20of%20an%20explorer%20team%20facing%20a%20giant%20glowing%20ruin%20in%20a%20lush%20jungle%2C%20torches%20and%20magic%20runes%2C%20emerald%20green%20and%20gold%20tones%2C%20epic%20discovery%20mood%2C%20clean%20jungle%20background%2C%20high%20detail%20fantasy%20illustration&width=600&height=800&seq=manhua-11&orientation=portrait",
    category: "玄幻奇幻",
    author: "猎奇者",
    status: "连载中",
    score: 8.6,
    description: "落魄考古学家带队进入传说中的失落秘境，古文明遗迹中隐藏着足以改变世界的力量。冒险与阴谋并存。",
    tags: ["冒险", "奇幻", "寻宝", "秘境"],
    chapters: 104,
    updateTime: "5天前",
    views: 2380000,
    isEditorPick: false,
    isHot: false,
    region: "国产",
    year: 2023,
    lastChapter: "第104话 遗迹之门",
  },
  {
    id: "manhua-shijianfengxi",
    title: "时间缝隙",
    cover: "https://readdy.ai/api/search-image?query=Time%20travel%20suspense%20anime%20manga%20cover%20art%20of%20a%20figure%20walking%20through%20a%20glowing%20crack%20in%20a%20clock%20face%2C%20fragmented%20shards%20floating%2C%20moody%20purple%20and%20deep%20blue%20tones%20with%20gold%20light%2C%20mysterious%20atmosphere%2C%20clean%20dark%20background%2C%20high%20detail%20sci-fi%20thriller%20illustration&width=600&height=800&seq=manhua-12&orientation=portrait",
    category: "悬疑推理",
    author: "时之砂",
    status: "已完结",
    score: 9.0,
    description: "女孩叶知秋发现只要触碰时钟的某个缝隙，就能回到过去的十分钟。她一次次试图改写悲剧，却发现命运如同螺旋般难以挣脱。",
    tags: ["悬疑", "穿越", "科幻", "反转"],
    chapters: 96,
    updateTime: "已完结",
    views: 4590000,
    isEditorPick: false,
    isHot: false,
    region: "国产",
    year: 2022,
    lastChapter: "全书完",
  },
  {
    id: "manhua-xingjianshaonv",
    title: "星舰少女",
    cover: "https://readdy.ai/api/search-image?query=Cute%20sci-fi%20space%20anime%20manga%20cover%20art%20of%20a%20young%20girl%20in%20a%20space%20suit%20on%20a%20starship%20bridge%2C%20glowing%20holographic%20screens%2C%20warm%20coral%20and%20soft%20blue%20tones%2C%20friendly%20adventurous%20mood%2C%20clean%20spaceship%20background%2C%20high%20detail%20sci-fi%20illustration&width=600&height=800&seq=manhua-13&orientation=portrait",
    category: "科幻机甲",
    author: "小行星",
    status: "已完结",
    score: 8.5,
    description: "废土孤儿小雨意外继承了一艘失落的星舰，招募一群性格迥异的船员，在广袤宇宙中开启吃货与冒险交织的旅程。",
    tags: ["科幻", "太空", "冒险", "治愈"],
    chapters: 168,
    updateTime: "已完结",
    views: 3120000,
    isEditorPick: false,
    isHot: false,
    region: "国产",
    year: 2019,
    lastChapter: "全书完",
  },
  {
    id: "manhua-nianhuahuakai",
    title: "那年花开",
    cover: "https://readdy.ai/api/search-image?query=School%20youth%20drama%20anime%20manga%20cover%20art%20of%20a%20classroom%20window%20with%20blooming%20wisteria%20flowers%2C%20a%20girl%20looking%20out%20dreamily%2C%20soft%20pastel%20purple%20and%20warm%20cream%20tones%2C%20gentle%20nostalgic%20mood%2C%20clean%20background%2C%20high%20detail%20illustration&width=600&height=800&seq=manhua-14&orientation=portrait",
    category: "校园青春",
    author: "春晓",
    status: "连载中",
    score: 8.9,
    description: "毕业前最后一个春天，班长沈亦清决定为班级里每个同学记录下最难忘的瞬间。一封封未完的情书，藏着整个青春的暗涌。",
    tags: ["青春", "校园", "友情", "温情"],
    chapters: 78,
    updateTime: "2天前",
    views: 2810000,
    isEditorPick: false,
    isHot: false,
    region: "国产",
    year: 2024,
    lastChapter: "第78话 花开时节",
  },
  {
    id: "manhua-xiantuwendao",
    title: "仙途问道",
    cover: "https://readdy.ai/api/search-image?query=Daoist%20immortal%20xianxia%20anime%20manga%20cover%20art%20of%20a%20young%20cultivator%20meditating%20on%20a%20cliff%20peak%2C%20floating%20sword%20and%20lotus%20blossoms%2C%20golden%20and%20sage%20green%20palette%2C%20misty%20mountains%20below%2C%20zen%20epic%20mood%2C%20clean%20sky%20background%2C%20high%20detail%20fantasy%20illustration&width=600&height=800&seq=manhua-15&orientation=portrait",
    category: "古风仙侠",
    author: "青莲",
    status: "已完结",
    score: 9.1,
    description: "资质平庸的少年洛尘拜入昆仑，在漫长仙途中历经劫难、背叛与重逢。问道求仙，亦是为守护所爱之人。",
    tags: ["仙侠", "修行", "宗门", "成长"],
    chapters: 356,
    updateTime: "已完结",
    views: 7820000,
    isEditorPick: true,
    isHot: false,
    region: "国产",
    year: 2020,
    lastChapter: "全书完",
  },
  {
    id: "manhua-huanlemanwu",
    title: "欢乐满屋",
    cover: "https://readdy.ai/api/search-image?query=Cozy%20family%20comedy%20anime%20manga%20cover%20art%20of%20a%20happy%20family%20of%20four%20gathered%20in%20a%20warm%20living%20room%2C%20colorful%20decorations%20and%20food%2C%20bright%20orange%20and%20cream%20tones%2C%20warm%20cozy%20atmosphere%2C%20clean%20background%2C%20high%20detail%20heartwarming%20illustration&width=600&height=800&seq=manhua-16&orientation=portrait",
    category: "搞笑轻松",
    author: "团团",
    status: "连载中",
    score: 8.8,
    description: "退休老爸开了一家杂货铺，一家四口在吵吵闹闹的日常里互相治愈。笑中带泪的温馨家庭故事。",
    tags: ["搞笑", "家庭", "温馨", "日常"],
    chapters: 120,
    updateTime: "8小时前",
    views: 3440000,
    isEditorPick: false,
    isHot: true,
    region: "国产",
    year: 2023,
    lastChapter: "第120话 全家福",
  },
];

export const hotTags = [
  "热血", "恋爱", "玄幻", "仙侠", "悬疑", "科幻", "机甲", "校园", "治愈", "搞笑", "末世", "穿越", "甜宠", "格斗", "冒险",
];

export function formatViews(v: number): string {
  if (v >= 100000000) return `${(v / 100000000).toFixed(1)}亿`;
  if (v >= 10000) return `${(v / 10000).toFixed(0)}万`;
  return `${v}`;
}